<template>
  <div v-loading="loading" class="tuihuo_pupop">
    <div class="tuihuo_form" style="position: relative">
      <div
        v-preventReClick
        style="
          position: absolute;
          right: 30px;
          top: 30px;
          font-size: 30px;
          color: #606266;
          cursor: pointer;
        "
        @click="back"
      >
        <i class="el-icon-circle-close" />
      </div>
      <div class="form_content">
        <img
          src="@/assets/img/thrkxx.png"
          style="height: 25px; margin-bottom: 37px"
        >
        <el-form
          ref="form"
          :rules="rule"
          :model="form"
          label-width="140px"
          label-position="right"
        >
          <el-form-item label="退货出库单号:" prop="thckBh">
            <el-select
              v-model="form.thckBh"
              filterable
              clearable
              :disabled="checkshow || bgdisable"
              style="width: 100%"
              placeholder="请填写出库单号"
            >
              <el-option
                v-for="item in thckDhList"
                :key="item.label"
                :label="item.label"
                :value="item.label"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="购买单位名称:" :required="true">
            <el-input
              v-model="form.gmdwMc"
              disabled
              placeholder="请填写购买单位名称"
            />
          </el-form-item>
          <el-form-item label="统一社会信用代码:" :required="true">
            <el-input
              v-model="form.gmdwShtyxydm"
              disabled
              placeholder="请填写统一社会信用代码"
            />
          </el-form-item>

          <el-form-item label="化学品:" :required="true">
            <el-input v-model="form.hxpMc" disabled />
          </el-form-item>
          <el-form-item label="存放仓库:" prop="ckId">
            <el-select
              v-if="!checkshow"
              v-model="form.ckId"
              :disabled="checkshow"
              style="width: 100%"
              placeholder="请选择"
              @change="cfckChange"
            >
              <el-option
                v-for="item in ckList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-input v-else v-model="form.ckmc" disabled />
          </el-form-item>
          <el-form-item label="保管员姓名:" :required="true">
            <el-input v-model="form.bgyxm" disabled />
          </el-form-item>
          <el-form-item label="保管员电话:" :required="true">
            <el-input v-model="form.bgydh" disabled />
          </el-form-item>

          <el-form-item label="入库数量:" prop="rksl">
            <el-input
              v-model="form.rksl"
              :disabled="checkshow"
              style="width: 65%"
              placeholder="请输入"
            />
            <el-select
              v-model="form.rkslDw"
              style="width: calc(35% - 10px); margin-left: 10px"
              :disabled="checkshow"
              placeholder="请选择"
            >
              <el-option
                v-for="item in hxpDwList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="入库日期:" prop="rkrq">
            <el-date-picker
              v-model="form.rkrq"
              :picker-options="pickerBeginDateBefore"
              :disabled="checkshow"
              style="width: 100%"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
            />
          </el-form-item>
          <el-form-item label="经办人:" prop="jbrId">
            <el-select
              v-if="!(checkshow || bgdisable)"
              v-model="form.jbrId"
              filterable
              :disabled="checkshow || bgdisable"
              style="width: 100%"
              placeholder="请选择"
              @change="jbrChange"
            >
              <el-option
                v-for="item in jbrList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-input v-else v-model="form.jbrName" disabled />
          </el-form-item>
          <el-form-item v-if="djrqdisable" label="登记日期:" :required="true">
            <el-input v-model="form.djsj" disabled />
          </el-form-item>
          <el-form-item v-else label="登记日期:">
            <el-date-picker
              :value="new Date()"
              type="date"
              style="width: 100%;"
              placeholder="选择日期"
              disabled
              format="yyyy-MM-dd"
            />
          </el-form-item>
          <el-form-item label="登记人:" :required="true">
            <el-input v-model="djr" disabled />
          </el-form-item>
          <el-form-item
            v-if="childrenType == 'bg'"
            label="变更理由:"
            style="width: 100%"
            prop="bgly"
            :rules="{
              required: true,
              validator: (rule, value, callback) => {
                lengthValidate(rule, value, callback, 'bt', 1000);
              },
              trigger: ['blur', 'change'],
            }"
          >
            <el-input
              v-model="form.bgly"
              resize="none"
              style="width: 100%"
              type="textarea"
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item
            label="备注:"
            style="width: 100%"
            prop="bz"
            :rules="{
              validator: (rule, value, callback) => {
                lengthValidate(rule, value, callback, 'xt', 225);
              },
              trigger: ['blur', 'change'],
            }"
          >
            <el-input
              v-model="form.bz"
              resize="none"
              :disabled="checkshow || bgdisable"
              style="width: 100%"
              type="textarea"
              placeholder="请输入"
            />
          </el-form-item>
        </el-form>
        <div
          v-if="
            childrenType == 'add' ||
              childrenType == 'bj' ||
              childrenType == 'copy' ||
              !curRowObjthrk.bgcs
          "
        >
          <!-- 新增 -->
          <div
            v-if="
              (!djrqdisable && !checkshow && !bgdisable) ||
                this.childrenType == 'copy'
            "
            class="buttonList"
          >
            <el-button
              v-preventReClick
              class="zsbc"
              @click="saveTemp"
            >暂时保存</el-button>
            <el-button
              v-preventReClick
              class="tjsq"
              @click="save(1)"
            >入库</el-button>
          </div>

          <!-- 查看 -->
          <div
            v-if="
              djrqdisable &&
                checkshow &&
                !bgdisable &&
                this.childrenType !== 'copy'
            "
            class="XINbuttonList"
          >
            <el-button
              v-preventReClick
              class="tjsq"
              @click="back"
            >确定</el-button>
          </div>

          <!-- 变更 -->
          <div
            v-if="djrqdisable && !checkshow && bgdisable"
            class="XINbuttonList"
          >
            <el-button
              v-preventReClick
              class="tjsq"
              @click="submitBg"
            >提交变更</el-button>
          </div>

          <!-- 编辑  -->
          <div
            v-if="djrqdisable && !checkshow && !bgdisable && this.childrenType != 'copy'"
            class="buttonList"
          >
            <el-button
              v-preventReClick
              class="zsbc"
              @click="saveTemp"
            >暂时保存</el-button>
            <el-button
              v-preventReClick
              class="tjsq"
              @click="save(1)"
            >入库</el-button>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="
        childrenType !== 'add' &&
          childrenType !== 'bj' &&
          childrenType !== 'copy' &&
          curRowObjthrk.bgcs > 0
      "
      class="tuihuo_content_list"
    >
      <div class="thcontent_content">
        <img
          src="@/assets/img/bgsp/rkbg.png"
          style="height: 25px; margin-bottom: 37px"
        >
        <bgcsOfDetail
          :cur-row-obj="curRowObjthrk"
          :cur-type="'9'"
          :bgcs-t-k-name="'disShow'"
          @bacsCkXqShow="bacsCkXqShow"
        />
        <div>
          <!-- 查看 -->
          <div
            v-if="djrqdisable && checkshow && !bgdisable"
            class="XINbuttonList"
          >
            <el-button
              v-preventReClick
              class="tjsq"
              @click="back"
            >确定</el-button>
          </div>

          <!-- 变更 -->
          <div
            v-if="djrqdisable && !checkshow && bgdisable"
            class="XINbuttonList"
          >
            <el-button
              v-preventReClick
              class="tjsq"
              @click="submitBg"
            >提交变更</el-button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="dialogFormVisible" class="purchase_pupop">
      <!-- 详情弹框 -->
      <el-dialog :visible.sync="dialogFormVisible" width="1200px" center>
        <bgxqCom
          v-if="dialogFormVisible"
          :bgcs-t-k-name="'内部使用退回'"
          :dgcs-xq-id="dgcsXqId"
        />
        <div slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            style="background-color: #4170ff; border: none"
            @click="dialogFormVisible = false"
          >确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { lengthValidate } from '@/assets/js/validate'
import { getCkxxByCskc, gethqdw } from '@/assets/js/ccgl.js'
import { userInfofLogin } from '@/assets/js/common.js'
import bgcsOfDetail from '../bgxq/bgInDetail.vue'
import bgxqCom from '../bgxq/bgxqCom.vue'
import {
  getThckXgxx,
  getLyrList,
  addOrUpdSave,
  changePdkcByThrk,
  saveChangeApply, addOrUpdSaveTemp
} from '@/assets/js/thrk.js'
import { isEmpty } from '@/utils/tool'

export default {
  components: { bgcsOfDetail, bgxqCom },
  props: [
    'djrqdisable',
    'checkshow',
    'bgdisable',
    'childrenType',
    'curRowObjthrk'
  ],
  data() {
    const sljiaoyan = (rule, value, callback) => {
      // 因为 0 隐式转换!0 = false;所以+'' 查看的时候不校验
      if (!(this.form.rksl + '')) {
        return callback(new Error('请填写入库数量'))
      }
      const reg = /^(0|[1-9][0-9]*)(\.\d+)?$/
      if (!this.bgdisable && !reg.test(this.form.rksl)) {
        callback(new Error('请输入大于或等于0的数量值'))
      } else if (
        /^-?[1-9]\d{0,8}(\.\d{1,3})?$|^-?0(\.\d{1,3})?$/.test(value) == false
      ) {
        return callback(new Error('整数位最大长度9位,保留3位小数'))
      }
      if (!this.form.rkslDw) {
        return callback(new Error('请选择入库数量单位'))
      }
      callback()
    }
    return {
      loading: false,
      dgcsXqId: null,
      dialogFormVisible: false,
      curType: '',
      curRowObj: {}, // 当前行的对象
      bgcsTKName: '购买入库',
      bgwindow: false,
      ckList: [], // 仓库list
      thckDhList: [], // 退货入库单号List
      djr: '', // 登记人
      hxpDwList: [], // 化学品单位list
      jbrList: [], // 经办人list
      form: {},
      // 日期限制
      pickerBeginDateBefore: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      /* 校验 */
      rule: {
        thckBh: [
          { required: true, message: '请选择退货出库单号', trigger: 'change' }
        ],
        ckId: [
          { required: true, message: '请选择存放仓库', trigger: 'change' }
        ],
        rksl: [{ required: true, validator: sljiaoyan, trigger: 'change' }],

        rkrq: [
          { required: true, message: '请选择入库日期', trigger: 'change' }
        ],
        jbrId: [{ required: true, message: '请选择经办人', trigger: 'change' }]
        // bgly: [
        //   { required: true, message: "请填写变更理由", trigger: "change" },
        // ],
      }
    }
  },
  computed: {},
  watch: {
    'form.thckBh'(newValue, oldValue) {
      if (oldValue && newValue != oldValue) {
        this.form.rkslDw = '' // 入库数量单位
      }
      if (!isEmpty(newValue)) {
        this.thckDhList.filter((item, index) => {
          if (item.label == newValue) {
            this.form.thckId = item.value // 退货出库主键
            this.form.gmdwMc = item.gmdwmc // 购买单位名称
            this.form.gmdwShtyxydm = item.gmdwShtyxydm // 统一社会信用代码
            this.form.hxpBm = item.hxpBm // 化学品编码
            this.form.hxpMc = item.hxpMc // 化学品名称
            // 通过化学品编码获取单位列表
          }
        })
        if (this.form.hxpBm) {
          gethqdw(this.form.hxpBm).then((e) => {
            this.hxpDwList = e.data.data
          })
        }
      } else {
        this.form.thckId = ''
      }
    }
  },
  mounted() {
    this.loadDataSource()
  },
  created() {},
  beforeDestroy() {},
  methods: {
    lengthValidate,
    bacsCkXqShow(id) {
      this.dgcsXqId = id
      this.dialogFormVisible = !this.dialogFormVisible
    },
    // 关闭窗口
    handleCloseBindWarnStandard() {
      this.bgwindow = false
    },
    // 提交变更
    submitBg() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          // 校验是否为负数
          changePdkcByThrk({
            id: this.form.id,
            hxpBm: this.form.hxpBm,
            ckId: this.form.ckId,
            rksl: this.form.rksl,
            rkslDw: this.form.rkslDw
          }).then((e) => {
            var str =
              e.data.data.type == 'success'
                ? '是否确认提交变更?'
                : "<span style='color:red'>" +
                  e.data.data.msg +
                  '</span>' +
                  '是否确认提交变更?'
            this.$confirm(str, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              dangerouslyUseHTMLString: true,
              type: 'warning'
            })
              .then(() => {
                // 提交变更
                this.loading = true
                saveChangeApply(this.form).then((e) => {
                  this.loading = false
                  if (e.data.code == '000000') {
                    // 回到父页面 清空本页面
                    this.$parent.pupopShow = false
                    this.$parent.multipleSelection = []
                    this.form = {}
                    this.$parent.search()
                    this.$message({
                      message: '变更成功!',
                      type: 'success'
                    })
                  }
                }).catch((error) => {
                  this.loading = false
                })
              })
              .catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消'
                })
              })
          })
        }
      })
    },
    // 经办人回调
    jbrChange(val) {
      this.jbrList.filter((item, index) => {
        if (item.value == val) {
          this.form.jbrId = item.value // 经办人id
          this.form.jbrName = item.label // 经办人姓名
        }
      })
    },
    // 存放仓库回调
    cfckChange(val) {
      this.ckList.filter((item, index) => {
        if (item.value == val) {
          this.form.ckmc = item.label // 仓库名称
          this.form.bgyId = item.ckbgyId // 保管员id
          this.form.bgyxm = item.ckbgy
          this.form.bgydh = item.ckbgyDh
        }
      })
    },
    // 加载相关数据
    loadDataSource() {
      getThckXgxx().then((e) => {
        this.thckDhList = e.data.data
      })

      userInfofLogin().then((e) => {
        this.djr = e.data.data.name
      })

      if (this.childrenType == 'add') { // 新增
        this.getCkxxAndJbr()
      }
    },
    // 加载仓库/经办人下拉
    getCkxxAndJbr(dataMes) {
      if (this.bgdisable) { // 变更
        getCkxxByCskc(dataMes.ckId).then((e) => {
          this.ckList = e.data.data
          this.form.ckId = dataMes.ckId
          this.form.ckmc = dataMes.ckmc
        })
      } else {
        getCkxxByCskc().then((e) => {
          this.ckList = e.data.data
          if (dataMes && dataMes.ckId) {
            this.ckList.findIndex((item) => {
              if (item.value == dataMes.ckId) {
                this.form.ckId = dataMes.ckId
                this.form.ckmc = dataMes.ckmc
                this.form.bgyId = dataMes.bgyId
                this.form.bgydh = dataMes.bgydh
                this.form.bgyxm = dataMes.bgyxm
                return
              }
            })
          }
        })
        getLyrList().then((e) => {
          this.jbrList = e.data.data
          if (dataMes && dataMes.jbrId) {
            this.jbrList.findIndex((item) => {
              if (item.value == dataMes.jbrId) {
                this.form.jbrId = dataMes.jbrId
                this.form.jbrName = dataMes.jbrName
                return
              }
            })
          }
        })
      }
    },
    // 编辑/复制新增/变更
    loadData(dataMes) {
      const mesxx = { ...dataMes }
      mesxx.ckId = this.form.ckId
      mesxx.ckmc = this.form.ckmc
      if (!this.bgdisable) { // 非变更
        mesxx.bgyId = this.form.bgyId
        mesxx.bgydh = this.form.bgydh
        mesxx.bgyxm = this.form.bgyxm
        mesxx.jbrId = this.form.jbrId
        mesxx.jbrName = this.form.jbrName
      }
      this.form = mesxx
      this.getCkxxAndJbr(dataMes)
      this.$nextTick(() => {
        this.$refs.form.clearValidate() //清楚页面所有校验结果
      })
    },
    // 返回父组件
    back() {
      this.$parent.pupopShow = false
      this.$parent.multipleSelection = []
      this.form = {}
      this.$parent.childrenType = ''
    },
    // 暂存
    saveTemp() {
      this.$confirm('是否暂时保存本次退货入库操作', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.form.zt = '00'
          this.childrenType == 'copy' ? this.$delete(this.form, 'id') : ''
          this.loading = true
          addOrUpdSaveTemp(this.form).then((e) => {
            this.loading = false
            if (e.data.code == '000000') {
              this.$parent.pupopShow = false
              this.$parent.multipleSelection = []
              this.form = {}
              this.$parent.search()
              this.$message({
                message: '提交成功!',
                type: 'success'
              })
            }
          }).catch((error) => {
            this.loading = false
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 提交
    save(type) {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          var arr = type == 0 ? '暂时保存' : '提交'
          this.$confirm('是否' + arr + '本次退货入库操作', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              this.form.zt = type == 0 ? '00' : '01'
              this.childrenType == 'copy' ? this.$delete(this.form, 'id') : ''
              this.loading = true
              addOrUpdSave(this.form).then((e) => {
                this.loading = false
                if (e.data.code == '000000') {
                  this.$parent.pupopShow = false
                  this.$parent.multipleSelection = []
                  this.form = {}
                  this.$parent.search()
                  this.$message({
                    message: '提交成功!',
                    type: 'success'
                  })
                }
              }).catch((error) => {
                this.loading = false
              })
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              })
            })
        }
      })
    }
  }
}
</script>
<style scoped lang='less'>
.tuihuo_pupop {
  padding-top: 10px;
  .tuihuo_form {
    width: 90%;
    max-width: 1200px;
    background-color: white;
    margin: auto;
    .form_content {
      width: 80%;
      margin: auto;
      padding-top: 40px;
      padding-bottom: 10px;
      .el-form {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .el-form-item {
          margin-right: 0;
          width: 45%;
        }
      }
      .buttonList {
        width: 498px;
        margin-left: auto;
        margin-right: auto;
        margin-top: 40px;
        margin-bottom: 45px;
        display: flex;
        justify-content: center;
        .el-button:nth-child(1) {
          margin-right: 190px;
          background-color: #ebebeb;
          width: 148px;
          height: 60px;
          color: #333333;
          border: none;
        }
        .el-button:nth-child(2) {
          background-color: #4170ff;
          color: white;
          width: 148px;
          height: 60px;
          border: none;
        }
      }

      .XINbuttonList {
        width: 498px;
        margin-left: auto;
        margin-right: auto;
        margin-top: 40px;
        margin-bottom: 45px;
        text-align: center;
        .el-button {
          background-color: #4170ff;
          color: white;
          width: 148px;
          height: 60px;
          border: none;
        }
      }
    }
  }
  .tuihuo_content_list {
    width: 90%;
    max-width: 1200px;
    background-color: white;
    margin: auto;
    margin-top: 15px;
    .thcontent_content {
      width: 80%;
      margin: auto;
      padding-top: 40px;
      padding-bottom: 10px;
      .el-form {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .el-form-item {
          margin-right: 0;
          width: 45%;
        }
      }
      .buttonList {
        width: 498px;
        margin-left: auto;
        margin-right: auto;
        margin-top: 40px;
        margin-bottom: 45px;
        display: flex;
        justify-content: center;
        .el-button:nth-child(1) {
          margin-right: 190px;
          background-color: #ebebeb;
          width: 148px;
          height: 60px;
          color: #333333;
          border: none;
        }
        .el-button:nth-child(2) {
          background-color: #4170ff;
          color: white;
          width: 148px;
          height: 60px;
          border: none;
        }
      }
      .XINbuttonList {
        width: 498px;
        margin-left: auto;
        margin-right: auto;
        margin-top: 40px;
        margin-bottom: 45px;
        text-align: center;
        .el-button {
          background-color: #4170ff;
          color: white;
          width: 148px;
          height: 60px;
          border: none;
        }
      }
    }
  }
}
</style>
